import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export let startPeopleApp = (
  courseData,
  peopleData,
  sectionData,
  allSectionData,
  elevatedUser,
  chapterData,
  archivedData,
  videoData,
  peopleCount,
  archivedCount,
  sectionCount,
  supportDashboard
) => {
  const root = createRoot(document.getElementById('app'))
  root.render(
    <App
      courseData={courseData}
      peopleData={peopleData}
      sectionData={sectionData}
      allSectionData={allSectionData}
      elevatedUser={elevatedUser}
      chapterData={chapterData}
      archivedData={archivedData}
      videoData={videoData}
      peopleCount={peopleCount}
      archivedCount={archivedCount}
      sectionCount={sectionCount}
      supportDashboard={supportDashboard}
    />
  )
}
